module.exports = {
  users: 'User',
  company: 'Company',
  branchOffices: 'BranchOffices',
  orders: 'Orders',
  products: 'Products',
  cart: 'Cart',
  establishmentType: 'EstablishmentType',
  modifications: 'Modifications',
  category: 'Category',
  history: 'History',
  basket: 'Basket',
  accessLog: 'AccessLog',
  zones: 'Zones',
  province: 'Province',
  driver: 'Driver',
  services: 'Services',
  banner: 'Banners'
}